<template>
  <div>
    <el-card :body-style="cardBodyStyle">
      <el-form label-width="80px" :inline="true" ref="form" :model="form" :rules="formRules">

        <el-form-item label="表名" prop="tableName">
          <el-input v-model="form.tableName" @input="handleInputTableName" size="small" style="width: 200px;">
          </el-input>
        </el-form-item>
        <el-form-item label="表名前缀" prop="tablePrefix">
          <el-input v-model="form.tablePrefix" @input="handleInputTablePrefix" size="small" placeholder="T_TEST"
            style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="服务名" prop="moduleName">
          <el-input v-model="form.moduleName" size="small" placeholder="test" style="width: 200px;"
            @input="handleModuleNameInput">
          </el-input>
        </el-form-item>
<!--        <el-form-item label="微服务名" prop="serviceName">
          <el-input v-model="form.serviceName" size="small" placeholder="service-test" style="width: 200px;">
          </el-input>
        </el-form-item>-->
        <el-form-item label="包名" prop="parentPackageName">
          <el-input v-model="form.parentPackageName" size="small"
            style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="流程挂载" prop="vuePath">
          <el-input v-model="form.processKey" size="small" style="width: 200px;">
            <el-button slot="append" icon="el-icon-search" size="mini" @click="handlePopupProcess"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="流程挂载" prop="vuePath">
          <el-input v-model="form.processName" size="small" style="width: 200px;">
            <el-button slot="append" icon="el-icon-search" size="mini" @click="handlePopupProcess"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="vue路径" prop="vuePath">
          <el-input v-model="form.vuePath" size="small" placeholder="C:\workspaces\sgiip\Proj_SgIIP_Src_vue"
            style="width: 495px;">
             <template slot="append">/src/view/{{form.moduleName}}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="vue固定列">
          <el-checkbox v-model="form.fixedFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card :body-style="cardBodyStyle">
      <el-button size="mini" type="primary" @click="handleSearch('form')">查询</el-button>
      <el-button size="mini" type="success" @click="handleSave('form')">保存</el-button>
      <el-button size="mini" type="warning" @click="handleGenerate('form')">生成</el-button>
    </el-card>




    <el-card :body-style="cardBodyStyle">
      <el-table :data="tableData" ref="tableData" border>
        <el-table-column prop="sort" type="index" label="序号" align="center" width="60">
        </el-table-column>
        <el-table-column label="数据库" header-align="center">
          <el-table-column prop="fieldName" label="字段名" width="140" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="fieldComment" label="注释" width="140" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="fieldType" label="字段类型" width="140" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>
          <!-- <el-table-column prop="length" label="长度" width="80" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="precision" label="精度" width="80" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="nullFlag" label="非空" width="80" header-align="center" align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.nullFlag"   true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="pkFlag" label="主键" width="80" header-align="center" align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.pkFlag"   true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column> -->
        </el-table-column>

        <el-table-column label="表单" header-align="center">
          <el-table-column prop="controllerType" label="控件" width="120" header-align="center" align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">

              <el-select v-model="scope.row.controllerType" size="small" style="width: 100px;">
                <el-option v-for="item in controllerTypeOptions" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>


          </el-table-column>
          <el-table-column prop="inputFlag" label="录入" width="80" header-align="center" align="center"
            show-overflow-tooltip :filters="[{text: '是', value: true}, {text: '否', value: false }]"
            :filter-method="filterHandler">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.inputFlag" true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="requireFlag" label="必填" width="80" header-align="center" align="center"
            show-overflow-tooltip>
            <template slot-scope="scope" :filters="[{text: '是', value: true}, {text: '否', value: false }]"
              :filter-method="filterHandler">
              <el-checkbox v-model="scope.row.requireFlag" true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="查询" header-align="center">
          <el-table-column prop="queryFlag" label="条件" width="80" header-align="center" align="center"
            show-overflow-tooltip :filters="[{text: '是', value: true}, {text: '否', value: false }]"
            :filter-method="filterHandler">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.queryFlag" true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="fuzzyFlag" label="模糊" width="80" header-align="center" align="center"
            show-overflow-tooltip :filters="[{text: '是', value: true}, {text: '否', value: false }]"
            :filter-method="filterHandler">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.fuzzyFlag" true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="dateFlag" label="范围" width="80" header-align="center" align="center"
            show-overflow-tooltip :filters="[{text: '是', value: true}, {text: '否', value: false }]"
            :filter-method="filterHandler">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.dateFlag" true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column>

        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="80px">
          <template slot-scope="scope">
            <el-button size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>





    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="dialogVisible" width="700px">
      <el-form label-width="80px" :inline="true" ref="tableField">
        <div>
          <el-form-item label="控件类型">
            <el-select v-model="tableField.controllerType" size="small" style="width: 100px;"
              @change="controllerTypeChange">
              <el-option v-for="item in controllerTypeOptions" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="录入">
            <el-checkbox v-model="tableField.inputFlag" true-label="1" false-label="0"></el-checkbox>
          </el-form-item>
          <el-form-item label="必填">
            <el-checkbox v-model="tableField.requireFlag" true-label="1" false-label="0"></el-checkbox>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="查询条件">
            <el-checkbox v-model="tableField.queryFlag" true-label="1" false-label="0"></el-checkbox>
          </el-form-item>
          <el-form-item label="模糊查询" v-if="fuzzyFlagVisible">
            <el-checkbox v-model="tableField.fuzzyFlag" true-label="1" false-label="0"></el-checkbox>
          </el-form-item>
          <el-form-item label="日期范围" v-if="dateFlagVisible">
            <el-checkbox v-model="tableField.dateFlag" true-label="1" false-label="0"></el-checkbox>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer">
        <el-button size="small" type="success" @click="handleComfirm('tableField')">确定</el-button>
        <el-button size="small" type="danger" @click="handleComfirmCancel">取消</el-button>
      </span>
    </el-dialog>


    <popup-process ref="PopupProcess" v-on:receiveFromChild="receiveFromPopupProcess"></popup-process>

  </div>
</template>

<script>
  import tools from '@/tools'
  import axios from '@/axios'
  import PopupProcess from '@/components/system/PopupProcess.vue'
  export default {
    components: {
      PopupProcess
    },

    data() {
      return {
        cardBodyStyle: tools.style.card,
        dialogVisible: false,
        tableData: [],
        form: {
          // tableName: 'T_TEST_LEE',
          // tablePrefix: 'T_TEST',
          // moduleName: 'test',
          // serviceName: 'service-test',
          // parentPackageName: 'com.shinsoft.servicetest',
          // processKey: '',
          // vuePath: 'C:\\workspaces\\sgiip\\Proj_SgIIP_Src_vue',
          // fixedFlag: '0',

          tableName: '',
          tablePrefix: '',
          moduleName: '',
          serviceName: '',
          parentPackageName: '',
          processKey: '',
          processName: '',
          vuePath: '',
          fixedFlag: '0'
        },
        formRules: {
          tableName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          tablePrefix: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          moduleName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          serviceName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          parentPackageName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
        },


        tableField: {
          fieldName: '',
          fieldType: 'VARCHAR2',
          fieldComment: '',
          length: 0,
          precision: 0,
          nullFlag: '0',
          pkFlag: '0',

          controllerType: '单行文本',
          inputFlag: '0',
          requireFlag: '0',

          queryFlag: '0',
          fuzzyFlag: '0',
          dateFlag: '0',
        },


        controllerTypeOptions: [{
          value: '单行文本',
          label: '单行文本'
        }, {
          value: '多行文本',
          label: '多行文本'
        }, {
          value: '下拉',
          label: '下拉'
        }, {
          value: '日期',
          label: '日期'
        }, {
          value: '日期时间',
          label: '日期时间'
        }],
        controllerAlignOptions: [{
          value: 'left',
          label: '左对齐'
        }, {
          value: 'center',
          label: '居中'
        }, {
          value: 'right',
          label: '右对齐'
        }],

        fuzzyFlagVisible: true,
        dateFlagVisible: true,


      }
    },

    methods: {
      filterHandler(value, row, column) {
        const property = column['property'];
        return row[property] === value;
      },
      handleModuleNameInput(value) {
        this.form.parentPackageName = 'com.shinsoft.' + value
        this.form.serviceName =  value
      },
      handleSearch(form) {
        // this.$refs[form].validate((valid) => {
        //   if (valid) {
        var url = 'framework/TableField/query.do'
        var param = {
          tableName: this.form.tableName
        }
        axios.post(url, param).then(response => {
          if (response.data.code == 0) {
            this.form.tablePrefix = response.data.data[0].tablePrefix
            this.form.moduleName = response.data.data[0].moduleName
            this.form.serviceName = response.data.data[0].serviceName
            this.form.parentPackageName = response.data.data[0].parentPackageName
            this.form.processKey = response.data.data[0].processKey
            this.form.processName = response.data.data[0].processName
            this.form.vuePath = response.data.data[0].vuePath
            this.tableData = response.data.data
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
             this.tableData = []
          }
        })
        //   } else {
        //     console.log('error submit!!');
        //     return false;
        //   }
        // })
      },
      controllerTypeChange(value) {
        if (value == '日期') {
          this.tableField.width = 100
        } else if (value == '日期时间') {
          this.tableField.width = 160
        }
      },
      handleEdit(row) {
        this.tableField = row
        this.dialogVisible = true
      },
      handleComfirm(row) {
        this.dialogVisible = false
      },
      handleComfirmCancel() {
        this.dialogVisible = false
      },
      controllerTypeChange(value) {
        if (value == '日期') {
          this.tableField.width = 100
          this.fuzzyFlagVisible = false
          this.dateFlagVisible = true
        } else if (value == '日期时间') {
          this.tableField.width = 160
          this.fuzzyFlagVisible = false
          this.dateFlagVisible = true
        } else {
          this.fuzzyFlagVisible = true
          this.dateFlagVisible = false
        }
      },

      handleSave(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            var url = 'framework/TableField/update.do'
            var param = {
              tableName: this.form.tableName,
              tablePrefix: this.form.tablePrefix,
              moduleName: this.form.moduleName,
              serviceName: this.form.serviceName,
              parentPackageName: this.form.parentPackageName,
              processKey: this.form.processKey,
               processName: this.form.processName,
              vuePath: this.form.vuePath,
              json: JSON.stringify(this.tableData)
            }
            axios.post(url, param).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                });
                this.handleSearch(form)
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败!' + response.data.msg
                });
              }
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },

      handleGenerate(form) {
        if (this.form.fixedFlag == '1' && (this.form.vuePath == '' || this.form.vuePath == null)) {
          this.$message({
            type: 'error',
            message: '生成vue代码，必须填写vue路径'
          });
          return
        }

        this.$confirm('此操作将覆盖现有代码,请谨慎操作,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.$refs[form].validate((valid) => {
            if (valid) {
              var url = this.form.moduleName + '/Generate/generate.do'
              var param = {
                jsonForm: JSON.stringify(this.form),
                jsonFileds: JSON.stringify(this.tableData)
              }
              axios.post(url, param).then(response => {
                if (response.data.code == 0) {
                  this.$message({
                    type: 'success',
                    message: '操作成功!'
                  });
                  this.handleSearch(form)
                } else {
                  this.$message({
                    type: 'error',
                    message: '操作失败!' + response.data.msg
                  });
                }
              })

            } else {
              console.log('error submit!!');
              return false;
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！！'
          });
        });
      },
      handlePopupProcess() {
        this.$refs.PopupProcess.show()
      },
      receiveFromPopupProcess(value) {
        this.form.processKey = value.key
        this.form.processName = value.name
      },
      handleInputTableName(value) {
        this.form.tableName = value.toUpperCase()
      },
      handleInputTablePrefix(value) {
        this.form.tablePrefix = value.toUpperCase()
      }

    }






  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/generater/code.vue